import choiceDelay from 'cccisd-game-selee-choice-delay';
import {
    components as eeComponents,
    componentTemplates as eeComponentTemplates,
    playerTemplates as eePlayerTemplates,
} from 'cccisd-laravel-selwebee';
import {
    components as leComponents,
    componentTemplates as leComponentTemplates,
    playerTemplates as lePlayerTemplates,
} from 'cccisd-laravel-selweble';

import avatarbuilder from 'cccisd-game-zoou-avatarbuilder';
import com0 from 'cccisd-game-zoou-com0';
import coop0 from 'cccisd-game-zoou-coop0';
import emp0 from 'cccisd-game-zoou-emp0';
import er0 from 'cccisd-game-zoou-er0';
import ic0 from 'cccisd-game-zoou-ic0';
import ini0 from 'cccisd-game-zoou-ini0';

export default {
    components: [
        avatarbuilder,
        com0,
        coop0,
        emp0,
        er0,
        ic0,
        ini0,
        choiceDelay,
        eeComponents.AboutStudentMC,
        eeComponents.AboutStudentMatrix,
        eeComponents.Assistant,
        eeComponents.Intro,
        eeComponents.FT,
        eeComponents.FTIntro,
        leComponents.Assistant,
    ],
    templates: {
        components: {
            matrix: [
                leComponentTemplates.SPSelWebMatrix,
                leComponentTemplates.SPSelWebFullMatrix,
                leComponentTemplates.SelWebMatrix,
                leComponentTemplates.SelWebFullMatrix,
            ],
            multipleChoice: [
                eeComponentTemplates.CometAndBearMC,
                eeComponentTemplates.CometOrBearMC,
                eeComponentTemplates.SocialAwarenessMC,
                eeComponentTemplates.SocialPicMC,
                eeComponentTemplates.SocialTextMC,
                leComponentTemplates.SPSelWebMC,
                leComponentTemplates.SPSelWebCEMC,
                leComponentTemplates.SelWebMC,
                leComponentTemplates.SelWebCEMC,
                leComponentTemplates.SelWebMatrixMC,
            ],
            video: [eeComponentTemplates.NoButtonVideo],
        },
        players: {
            flow: [
                eePlayerTemplates.EE,
                eePlayerTemplates.Vignette,
                eePlayerTemplates.RocketGame,
                eePlayerTemplates.Video,
                lePlayerTemplates.SPSelWeb,
                lePlayerTemplates.SPSelWebCE,
                lePlayerTemplates.SPSelWebNewPT,
                lePlayerTemplates.SelWeb,
                lePlayerTemplates.SelWebCE,
                lePlayerTemplates.SelWebNewPT,
                lePlayerTemplates.SelfReport,
                lePlayerTemplates.TeacherRating,
            ],
        },
    },
};
